export default "__VITE_ASSET__Cz9j9TOP__"